<template>
    <div class="container">
        <div class="container-main">
            <div class="main-handle">
                <el-button type="primary" size="mini" @click="goBackHandle">{{$t('goBack')}}</el-button>
                <el-button type="primary" size="mini" @click="addDialog = true">{{ $t('add') }}</el-button>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column :label="$t('image')" align="center" width="100">
                    <template slot-scope="scope">
                        <div class="picture">
                            <el-image :src="scope.row.awardDepot.image" v-if="scope.row.awardDepot">
                                <div slot="error" class="image-slot">
                                    <img src="../../assets/images/default.png" alt="">
                                </div>
                            </el-image>
                            <img src="../../assets/images/default.png" alt="" v-else>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="name" :label="$t('awardsName')" align="center" min-width="150" show-overflow-tooltip></el-table-column>
                <el-table-column :label="$t('prizeName')" align="center" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.awardDepot">{{ scope.row.awardDepot.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('prizeType')" align="center" width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.awardDepot.type === 101">{{ $t('inKind') }}</span>
                        <span v-else-if="scope.row.awardDepot.type === 102">{{ $t('virtual') }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('price')" align="center" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.awardDepot.faceValue }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('postage')" align="center" width="120" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.awardDepot.postage }}</span>
                    </template>
                </el-table-column>
                <!--<el-table-column :label="$t('quantity')" align="center" width="120" show-overflow-tooltip>-->
                <!--    <template slot-scope="scope">-->
                <!--        <span>{{ scope.row.awardDepot.name }}</span>-->
                <!--    </template>-->
                <!--</el-table-column>-->
                <el-table-column prop="sort" :label="$t('sortValue')" align="center" width="120" show-overflow-tooltip></el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    fixed="right"
                    width="180">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="editHandle(scope.row.id)">{{ $t('edit') }}
                        </el-button>
                        <el-button
                            class="red"
                            size="mini"
                            type="text"
                            @click="deleteHandle(scope.row.id)">{{ $t('delete') }}
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 添加 -->
        <Add
            :parent-dialog="addDialog"
            @parent-update="getListData"
            @parent-close="addDialog = false"/>
        <!-- 编辑 -->
        <Edit
            :parent-dialog="editDialog"
            :parent-id="itemId"
            @parent-update="getListData"
            @parent-close="editDialog = false"/>
    </div>
</template>

<script>
import {deleteLotteryAwards, queryLotteryAwardsList} from "@/api/modules/api";
import Add from '@/components/lottery/awards/Add'
import Edit from '@/components/lottery/awards/Edit'
export default {
    name: "LotteryAwards",
    // 组件
    components: {
        Add,
        Edit
    },
    props: {},
    data() {
        return {
            tableData: [],
            addDialog: false,
            itemId: '',
            editDialog: false
        }
    },
    // 计算属性
    computed: {
    
    },
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取数据列表
        getListData() {
            const params = {
                activityId: this.$route.params.id,
                page: 1,
                size: 100
            }
            queryLotteryAwardsList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteLotteryAwards(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
        // 返回
        goBackHandle () {
            this.$router.go(-1)
        }
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
.main-handle{
    width: 100%;
    height: 60px;
    text-align: right;
}
</style>
